module.exports = __webpack_public_path__ + "static/media/joinedTournaments_75_100.c19baa37.png";